import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/front/Layout'),
    children: [
      {
        path: '/',
        redirect: "/login",
        component: () => import('../views/auth/Login')
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/Login')
      },
      {
        path: '/check-warranty',
        name: 'warranty_check',
        component: () => import('../views/front/warranty_check')
      },
      {
        path: '/check-warranty-detail',
        name: 'warranty_check_detail_main',
        component: () => import('../views/front/warranty_check_detail')
      },
      {
        path: '/check-warranty-detail/:keyword',
        name: 'warranty_check_detail',
        component: () => import('../views/front/warranty_check_detail')
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminLayout'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/admin/config',
        name: 'config',
        component: () => import('../views/admin/config'),
        meta: {
          group: 'config',
          requiresAuth: true
        }
      },
      {
        path: '/admin/product',
        name: 'product',
        component: () => import('../views/admin/product'),
        meta: {
          group: 'product',
          requiresAuth: true
        }
      },
      {
        path: '/admin/product/history/:id',
        name: 'history',
        component: () => import('../views/admin/product/view'),
        meta: {
          group: 'product',
          childs: ['product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/product/history-detail/:id',
        name: 'history_detail',
        component: () => import('../views/admin/product/view_detail'),
        meta: {
          group: 'product',
          childs: ['product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/product/function',
        name: 'product_function',
        component: () => import('../views/admin/product/function'),
        meta: {
          group: 'product',
          childs: ['product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/product/function/:id',
        name: 'product_function_edit',
        component: () => import('../views/admin/product/function'),
        meta: {
          group: 'product',
          childs: ['product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/organization',
        name: 'organization',
        component: () => import('../views/admin/organization'),
        meta: {
          group: 'organization',
          requiresAuth: true
        }
      },
      {
        path: '/admin/organization/function',
        name: 'organization_function',
        component: () => import('../views/admin/organization/function'),
        meta: {
          group: 'organization',
          childs: ['organization'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/organization/function/:id',
        name: 'organization_function_edit',
        component: () => import('../views/admin/organization/function'),
        meta: {
          group: 'organization',
          childs: ['organization'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-activation',
        name: 'warranty_activation',
        component: () => import('../views/admin/warranty_activation'),
        meta: {
          group: 'warranty_activation',
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-activation/view/:id',
        name: 'warranty_activation_view',
        component: () => import('../views/admin/warranty_activation/view'),
        meta: {
          group: 'warranty_activation',
          childs: ['warranty_activation'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-activation/view-detail/:id',
        name: 'warranty_activation_view_detail',
        component: () => import('../views/admin/warranty_activation/view_detail'),
        meta: {
          group: 'warranty_activation',
          childs: ['warranty_activation'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-violation',
        name: 'report_violation',
        component: () => import('../views/admin/report_violation'),
        meta: {
          group: 'report_violation',
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-violation/view/:id',
        name: 'report_violation_view',
        component: () => import('../views/admin/report_violation/view'),
        meta: {
          group: 'report_violation',
          childs: ['report_violation'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/serial-number',
        name: 'serial_number',
        component: () => import('../views/admin/serial_number'),
        meta: {
          group: 'serial_number',
          requiresAuth: true
        }
      },
      {
        path: '/admin/serial-number/add',
        name: 'serial_number_add',
        component: () => import('../views/admin/serial_number/function'),
        meta: {
          group: 'serial_number',
          requiresAuth: true
        }
      },
      {
        path: '/admin/serial-number/view/:id',
        name: 'serial_number_view',
        component: () => import('../views/admin/serial_number/function_view'),
        meta: {
          group: 'serial_number',
          childs: ['serial_number_add'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/serial-number/view-detail/:id',
        name: 'serial_number_view_detail',
        component: () => import('../views/admin/serial_number/view'),
        meta: {
          group: 'serial_number',
          childs: ['serial_number'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/serial-number/print',
        name: 'serial_number_print',
        component: () => import('../views/admin/serial_number/print'),
        meta: {
          group: 'serial_number',
          childs: ['serial_number'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/customer',
        name: 'customer',
        component: () => import('../views/admin/customer'),
        meta: {
          group: 'customer',
          requiresAuth: true
        }
      },
      {
        path: '/admin/customer/function/:id',
        name: 'customer_function',
        component: () => import('../views/admin/customer/function'),
        meta: {
          group: 'customer',
          childs: ['customer'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/customer/history/:id',
        name: 'customer_history',
        component: () => import('../views/admin/customer/view'),
        meta: {
          group: 'customer',
          childs: ['customer'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/customer/history-detail/:id',
        name: 'customer_history_detail',
        component: () => import('../views/admin/customer/view_detail'),
        meta: {
          group: 'customer',
          childs: ['customer'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/role',
        name: 'role',
        component: () => import('../views/admin/role'),
        meta: {
          group: 'role',
          requiresAuth: true
        }
      },
      {
        path: '/admin/role/function',
        name: 'role_function',
        component: () => import('../views/admin/role/function'),
        meta: {
          group: 'role',
          childs: ['role'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/role/function/:id',
        name: 'role_function_edit',
        component: () => import('../views/admin/role/function'),
        meta: {
          group: 'role',
          childs: ['role'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/user-level',
        name: 'user_level',
        component: () => import('../views/admin/user_level'),
        meta: {
          group: 'config',
          requiresAuth: true
        }
      },
      {
        path: '/admin/users',
        name: 'users',
        component: () => import('../views/admin/users'),
        meta: {
          group: 'users',
          requiresAuth: true
        }
      },
      {
        path: '/admin/users/function',
        name: 'users_function',
        component: () => import('../views/admin/users/function'),
        meta: {
          group: 'users',
          childs: ['users'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/users/function/:id',
        name: 'users_function_edit',
        component: () => import('../views/admin/users/function'),
        meta: {
          group: 'users',
          childs: ['users'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/appraisal-product',
        name: 'appraisal_product',
        component: () => import('../views/admin/appraisal_product'),
        meta: {
          group: 'appraisal_product',
          requiresAuth: true
        }
      },
      {
        path: '/admin/appraisal-product/function',
        name: 'appraisal_product_function',
        component: () => import('../views/admin/appraisal_product/function'),
        meta: {
          group: 'appraisal_product',
          childs: ['appraisal_product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/appraisal-product/view/:id',
        name: 'appraisal_product_view',
        component: () => import('../views/admin/appraisal_product/view'),
        meta: {
          group: 'appraisal_product',
          childs: ['appraisal_product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/appraisal-product/view-detail/:id',
        name: 'appraisal_product_view_detail',
        component: () => import('../views/admin/appraisal_product/view_detail'),
        meta: {
          group: 'appraisal_product',
          childs: ['appraisal_product'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/service-supplies',
        name: 'service_supplies',
        component: () => import('../views/admin/service_supplies'),
        meta: {
          group: 'service_supplies',
          requiresAuth: true
        }
      },
      {
        path: '/admin/service-park',
        name: 'service_park',
        component: () => import('../views/admin/service_park'),
        meta: {
          group: 'service_park',
          requiresAuth: true
        }
      },
      {
        path: '/admin/service-park/function',
        name: 'service_park_function',
        component: () => import('../views/admin/service_park/function'),
        meta: {
          group: 'service_park',
          childs: ['service_park'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/service-park/function/:id',
        name: 'service_park_function_edit',
        component: () => import('../views/admin/service_park/function'),
        meta: {
          group: 'service_park',
          childs: ['service_park'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-repair',
        name: 'warranty_repair',
        component: () => import('../views/admin/warranty_repair'),
        meta: {
          group: 'warranty_repair',
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-repair/function',
        name: 'warranty_repair_function',
        component: () => import('../views/admin/warranty_repair/function'),
        meta: {
          group: 'warranty_repair',
          childs: ['warranty_repair'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-repair/function/:id',
        name: 'warranty_repair_function_edit',
        component: () => import('../views/admin/warranty_repair/function'),
        meta: {
          group: 'warranty_repair',
          childs: ['warranty_repair'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/warranty-repair/view-detail/:id',
        name: 'warranty_repair_view_detail',
        component: () => import('../views/admin/warranty_repair/view_detail'),
        meta: {
          group: 'warranty_repair',
          childs: ['warranty_repair'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/maintenance',
        name: 'maintenance',
        component: () => import('../views/admin/maintenance'),
        meta: {
          group: 'maintenance',
          requiresAuth: true
        }
      },
      {
        path: '/admin/history-export',
        name: 'history_export',
        component: () => import('../views/admin/history_export'),
        meta: {
          group: 'history_export',
          requiresAuth: true
        }
      },
      {
        path: '/admin/report',
        name: 'report',
        component: () => import('../views/admin/report'),
        meta: {
          group: 'report',
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-warranty-activation',
        name: 'report_warranty_activation',
        component: () => import('../views/admin/report_warranty_activation'),
        meta: {
          group: 'report_warranty_activation',
          childs: ['report'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-appraisal-product',
        name: 'report_appraisal_product',
        component: () => import('../views/admin/report_appraisal_product'),
        meta: {
          group: 'report_appraisal_product',
          childs: ['report'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-warranty-repair',
        name: 'repair_warranty_maintenance',
        component: () => import('../views/admin/repor_warrantyt_repair'),
        meta: {
          group: 'repair_warranty_maintenance',
          childs: ['report'],
          requiresAuth: true
        }
      },
      {
        path: '/admin/report-service-supplies',
        name: 'report_service_supplies',
        component: () => import('../views/admin/report_service_supplies'),
        meta: {
          group: 'report_service_supplies',
          childs: ['report'],
          requiresAuth: true
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})


export default router
